import React, { Component } from 'react';

export default class InvitationText extends Component {
    render() {
        return (
            <div className={'invitation-text'}>
                <p>
                    {window
                        .VULOG_TRANSLATE('INVITATION_MESSAGE')
                        .replace('{business_name}', this.props.data.businessName)
                        .replace('{operator_name}', this.props.data.operatorName)}
                </p>
            </div>
        );
    }
}
